// Age Calculator Tool — exact age + totals + next birthday from a date of birth.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const ageCalculatorTool: Tool = {
  id: "age-calculator",
  name: () => m.age_tool_name(),
  description: () => m.age_tool_description(),
  icon: "🎂",
  basePath: "/age-calculator",
  status: "stable",
  tags: ["age", "date", "birthday", "calculator"],
  pages: [
    {
      name: () => m.age_nav_main(),
      path: "/age-calculator",
      description: () => m.age_nav_main_desc(),
      icon: "🎂",
    },
  ],
};
